var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _rect, _rect2, _rect3, _path22, _path23, _path24, _path25, _rect4, _rect5, _path26, _path27, _path28, _path29, _rect6, _rect7, _path30, _ellipse, _path31, _path32, _path33, _rect8, _rect9, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _rect10, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle, _path49, _path50, _circle2, _path51, _path52, _path53, _circle3, _path54, _path55, _path56, _circle4, _path57, _path58, _path59, _circle5, _path60, _path61, _path62;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStudentLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 190,
    viewBox: "0 0 204 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M193.832 151.465C188.046 142.916 181.324 132.763 183.243 121.851C186.498 110.734 194.425 101.406 200.267 91.6614C207.165 79.3947 201.908 75.3151 190.522 70.8183C186.609 69.3904 181.445 68.6023 177.625 66.9519C169.28 62.2511 170.003 54.268 158.098 48.9923C150.579 44.7922 143.467 46.0717 135.67 48.4824C129.198 50.1328 122.123 50.9394 115.457 50.7354C96.3107 49.5765 76.8769 48.5287 57.6934 48.8069C48.7183 49.0572 38.8345 49.15 30.1838 51.7924C18.2602 57.0218 8.72876 67.7307 7.68104 81.3233C6.68896 114.535 25.5015 120.998 21.153 133.199C17.5648 145.206 14.2919 168.738 26.2433 176.629C36.4052 181.125 57.9623 171.307 70.6091 171.353C82.9499 170.639 86.705 173.513 97.006 178.909C108.568 184.167 121.187 187.328 133.778 188.515C152.044 190.425 170.81 187.718 188.009 181.227C206.201 173.838 205.477 165.762 193.832 151.456V151.465Z",
    fill: "#1A1E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2824 32.3323L71.2431 31.528L71.1156 30.6746L70.9587 30.0076L70.7919 29.5172L70.5369 28.8797L70.2427 28.3206L69.762 27.5751L69.2226 26.8885L68.6831 26.3392L68.173 25.8979L67.663 25.5251L67.0941 25.172L66.4958 24.868L65.9759 24.6522L65.4855 24.4854L64.7204 24.2893L64.1614 24.201L63.6611 24.1519L63.0922 24.1323L62.6999 24.1421L62.1212 24.1912L61.5817 24.2696L61.0619 24.3873L60.6401 24.505L60.3164 24.6227L59.9633 24.7503L59.62 24.9072L59.2963 25.0641L59.0021 25.2211L58.5901 25.4859L58.1781 25.7703L57.9329 25.9665L57.7466 26.1136L57.5112 26.3294L57.2267 25.8684L56.7951 25.2309L56.442 24.7699L55.8927 24.1323L55.3337 23.5732L54.8138 23.0926L54.3822 22.7591L53.9408 22.4354L53.4308 22.0921L52.7834 21.7096L52.293 21.4546L51.626 21.1603L50.9394 20.8955L50.1646 20.6601L49.3897 20.4835L48.6835 20.3658L48.1342 20.307L47.4672 20.2579L47.0258 20.2481L46.2313 20.2776L45.6526 20.3266L45.1033 20.4051L44.4952 20.513L43.7203 20.7091L43.1711 20.8759L42.5139 21.1211L41.9646 21.3565L41.484 21.5919L41.0622 21.8175L40.5718 22.1118L40.1598 22.3962L39.7675 22.6708L39.5223 22.867L39.3653 22.9945L39.1692 23.1515L38.9632 23.328L38.7278 22.9161L38.1295 21.9842L37.5213 21.1505L36.9524 20.4443L36.413 19.846L35.8146 19.228L35.2261 18.6788L34.4709 18.0314L34.0197 17.6783L33.4508 17.2663L32.9407 16.923L32.4405 16.6092L31.9599 16.3247L31.4891 16.0697L30.7338 15.697L30.1649 15.4419L29.6451 15.236L29.0565 15.0104L28.2915 14.7652L27.6735 14.5886L27.0458 14.4317L26.4377 14.3042L25.7805 14.1963L25.1527 14.108L24.6035 14.0491L23.9855 14.0099L23.5245 13.9805H22.9654L22.3181 13.9903L21.7394 14.0197L21.141 14.0687L20.5525 14.1374L19.964 14.2257L19.3559 14.3336L18.8066 14.4513L18.2475 14.5886L17.659 14.7553L17.0901 14.9417L16.6193 15.1085L15.864 15.4027L15.2559 15.6773L14.7557 15.9128L14.2947 16.158L13.6277 16.5307L13.2255 16.7759L12.6959 17.1192L12.2545 17.4331L11.7641 17.796L11.2442 18.208L10.7734 18.6199L10.2241 19.13L9.78275 19.5713L9.32175 20.0618L8.76266 20.7091L8.29185 21.3173L7.90931 21.8469L7.50716 22.4354L7.23252 22.8964L6.84999 23.5634L6.5165 24.1814L6.22224 24.8091L5.9476 25.4565L5.72201 26.0646L5.49641 26.712L5.32966 27.2612L5.1433 27.9675L5.03541 28.4285L4.94713 28.8502L4.86866 29.3014L4.8 29.7232L4.75096 30.1548L4.6823 30.8218L4.64307 31.4103V32.3323H6.67344H71.2824Z",
    fill: "#F2F4F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M159.282 18.6018L159.243 17.7975L159.116 16.9442L158.959 16.2772L158.792 15.7867L158.537 15.1492L158.243 14.5901L157.762 13.8447L157.223 13.1581L156.683 12.6088L156.173 12.1674L155.663 11.7947L155.094 11.4416L154.496 11.1375L153.976 10.9217L153.486 10.755L152.72 10.5588L152.161 10.4705L151.661 10.4215L151.092 10.4019L150.7 10.4117L150.121 10.4607L149.582 10.5392L149.062 10.6569L148.64 10.7746L148.316 10.8923L147.963 11.0198L147.62 11.1767L147.296 11.3337L147.002 11.4906L146.59 11.7554L146.178 12.0399L145.933 12.2361L145.747 12.3832L145.511 12.599L145.227 12.138L144.795 11.5004L144.442 11.0394L143.893 10.4019L143.334 9.84276L142.814 9.36214L142.382 9.02865L141.941 8.70497L141.431 8.36167L140.783 7.97914L140.293 7.72412L139.626 7.42986L138.939 7.16503L138.165 6.92962L137.39 6.75307L136.683 6.63537L136.134 6.57652L135.467 6.52747L135.026 6.51766L134.231 6.54709L133.653 6.59613L133.103 6.6746L132.495 6.7825L131.72 6.97867L131.171 7.14541L130.514 7.39063L129.965 7.62603L129.484 7.86144L129.062 8.08703L128.572 8.38129L128.16 8.66574L127.767 8.94038L127.522 9.13655L127.365 9.26406L127.169 9.421L126.963 9.59755L126.728 9.18559L126.129 8.25378L125.521 7.42005L124.952 6.71384L124.413 6.11551L123.815 5.49758L123.226 4.9483L122.471 4.30093L122.02 3.94782L121.451 3.53586L120.941 3.19257L120.441 2.87869L119.96 2.59424L119.489 2.33922L118.734 1.9665L118.165 1.71147L117.645 1.50549L117.057 1.2799L116.291 1.03468L115.674 0.85813L115.046 0.701193L114.438 0.573682L113.78 0.465788L113.153 0.377511L112.603 0.31866L111.986 0.279426L111.525 0.25H110.965L110.318 0.259809L109.739 0.289234L109.141 0.338277L108.553 0.406937L107.964 0.495214L107.356 0.603108L106.807 0.72081L106.248 0.85813L105.659 1.02488L105.09 1.21124L104.619 1.37798L103.864 1.67224L103.256 1.94688L102.756 2.18228L102.295 2.4275L101.628 2.80022L101.226 3.04544L100.696 3.38874L100.255 3.70261L99.7641 4.06553L99.2442 4.47749L98.7734 4.88944L98.2241 5.39949L97.7827 5.84087L97.3217 6.3313L96.7627 6.97867L96.2918 7.5868L95.9093 8.11646L95.5072 8.70497L95.2325 9.16597L94.85 9.83296L94.5165 10.4509L94.2222 11.0786L93.9476 11.726L93.722 12.3341L93.4964 12.9815L93.3297 13.5308L93.1433 14.237L93.0354 14.698L92.9471 15.1198L92.8687 15.571L92.8 15.9927L92.751 16.4243L92.6823 17.0913L92.6431 17.6798V18.6018H94.6734H159.282Z",
    fill: "#F2F4F7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M111.401 50.273L111.383 49.8861L111.321 49.4756L111.246 49.1548L111.166 48.9189L111.043 48.6122L110.901 48.3433L110.67 47.9847L110.411 47.6544L110.151 47.3902L109.906 47.1779L109.66 46.9986L109.387 46.8287L109.099 46.6825L108.849 46.5787L108.613 46.4985L108.245 46.4041L107.976 46.3616L107.735 46.3381L107.462 46.3286L107.273 46.3333L106.995 46.3569L106.735 46.3947L106.485 46.4513L106.282 46.5079L106.127 46.5645L105.957 46.6259L105.792 46.7014L105.636 46.7768L105.494 46.8523L105.296 46.9797L105.098 47.1166L104.98 47.2109L104.89 47.2817L104.777 47.3855L104.64 47.1637L104.433 46.8571L104.263 46.6353L103.999 46.3286L103.73 46.0597L103.48 45.8285L103.272 45.6681L103.06 45.5124L102.814 45.3472L102.503 45.1632L102.267 45.0406L101.946 44.899L101.616 44.7716L101.243 44.6584L100.87 44.5735L100.531 44.5168L100.267 44.4885L99.9457 44.4649L99.7334 44.4602L99.3512 44.4744L99.0729 44.498L98.8086 44.5357L98.5161 44.5876L98.1434 44.682L97.8792 44.7622L97.563 44.8801L97.2988 44.9934L97.0676 45.1066L96.8648 45.2151L96.6288 45.3567L96.4307 45.4935L96.242 45.6256L96.124 45.72L96.0485 45.7813L95.9542 45.8568L95.8551 45.9417L95.7418 45.7436L95.454 45.2953L95.1615 44.8943L94.8878 44.5546L94.6283 44.2668L94.3405 43.9695L94.0574 43.7053L93.6941 43.3939L93.4771 43.2241L93.2035 43.0259L92.9581 42.8608L92.7175 42.7098L92.4863 42.573L92.2598 42.4503L91.8965 42.271L91.6229 42.1483L91.3728 42.0492L91.0897 41.9407L90.7217 41.8228L90.4245 41.7378L90.1225 41.6623L89.83 41.601L89.5138 41.5491L89.2119 41.5066L88.9477 41.4783L88.6504 41.4595L88.4287 41.4453H88.1597L87.8483 41.45L87.57 41.4642L87.2822 41.4878L86.9991 41.5208L86.716 41.5633L86.4234 41.6152L86.1592 41.6718L85.8903 41.7378L85.6072 41.818L85.3335 41.9077L85.1071 41.9879L84.7438 42.1294L84.4513 42.2616L84.2106 42.3748L83.9889 42.4927L83.668 42.672L83.4746 42.79L83.2198 42.9551L83.0075 43.1061L82.7716 43.2807L82.5215 43.4788L82.295 43.677L82.0308 43.9224L81.8185 44.1347L81.5968 44.3706L81.3278 44.682L81.1014 44.9745L80.9173 45.2293L80.7239 45.5124L80.5918 45.7341L80.4078 46.055L80.2474 46.3522L80.1058 46.6542L79.9737 46.9656L79.8652 47.2581L79.7567 47.5695L79.6765 47.8337L79.5868 48.1734L79.5349 48.3952L79.4925 48.5981L79.4547 48.8151L79.4217 49.018L79.3981 49.2256L79.3651 49.5464L79.3462 49.8295V50.273H80.3229H111.401Z",
    fill: "#F2F4F7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M193.698 35.5621L193.679 35.1752L193.618 34.7647L193.543 34.4439L193.462 34.208L193.34 33.9013L193.198 33.6323L192.967 33.2738L192.707 32.9435L192.448 32.6793L192.203 32.467L191.957 32.2877L191.684 32.1178L191.396 31.9715L191.146 31.8677L190.91 31.7875L190.542 31.6932L190.273 31.6507L190.032 31.6271L189.759 31.6177L189.57 31.6224L189.292 31.646L189.032 31.6837L188.782 31.7404L188.579 31.797L188.423 31.8536L188.254 31.9149L188.088 31.9904L187.933 32.0659L187.791 32.1414L187.593 32.2688L187.395 32.4056L187.277 32.5L187.187 32.5708L187.074 32.6746L186.937 32.4528L186.73 32.1461L186.56 31.9244L186.296 31.6177L186.027 31.3487L185.777 31.1176L185.569 30.9571L185.357 30.8014L185.111 30.6363L184.8 30.4523L184.564 30.3296L184.243 30.1881L183.913 30.0607L183.54 29.9474L183.167 29.8625L182.828 29.8059L182.563 29.7776L182.243 29.754L182.03 29.7493L181.648 29.7634L181.37 29.787L181.106 29.8248L180.813 29.8767L180.44 29.971L180.176 30.0512L179.86 30.1692L179.596 30.2824L179.365 30.3957L179.162 30.5042L178.926 30.6457L178.728 30.7826L178.539 30.9147L178.421 31.009L178.345 31.0704L178.251 31.1459L178.152 31.2308L178.039 31.0326L177.751 30.5844L177.458 30.1834L177.185 29.8436L176.925 29.5558L176.637 29.2586L176.354 28.9944L175.991 28.683L175.774 28.5131L175.5 28.315L175.255 28.1498L175.014 27.9988L174.783 27.862L174.557 27.7393L174.193 27.5601L173.92 27.4374L173.67 27.3383L173.387 27.2298L173.019 27.1118L172.721 27.0269L172.419 26.9514L172.127 26.8901L171.811 26.8382L171.509 26.7957L171.245 26.7674L170.947 26.7485L170.726 26.7344H170.457L170.145 26.7391L169.867 26.7532L169.579 26.7768L169.296 26.8099L169.013 26.8523L168.72 26.9042L168.456 26.9608L168.187 27.0269L167.904 27.1071L167.63 27.1968L167.404 27.277L167.041 27.4185L166.748 27.5506L166.508 27.6639L166.286 27.7818L165.965 27.9611L165.771 28.0791L165.517 28.2442L165.304 28.3952L165.068 28.5697L164.818 28.7679L164.592 28.9661L164.328 29.2114L164.115 29.4237L163.894 29.6596L163.625 29.971L163.398 30.2636L163.214 30.5183L163.021 30.8014L162.889 31.0232L162.705 31.344L162.544 31.6413L162.403 31.9432L162.271 32.2546L162.162 32.5472L162.054 32.8586L161.973 33.1228L161.884 33.4625L161.832 33.6842L161.789 33.8871L161.752 34.1042L161.719 34.307L161.695 34.5146L161.662 34.8355L161.643 35.1186V35.5621H162.62H193.698Z",
    fill: "#F2F4F7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M174.607 42.25L173.626 49.0866L167.643 50.3111L173.986 51.6785L175.587 57.9437L176.588 51.3723L182.291 50.0866L176.428 49.1479L174.607 42.25Z",
    fill: "#F2F4F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3566 42.25L10.3761 49.0866L4.39307 50.3111L10.7363 51.6785L12.3371 57.9437L13.3376 51.3723L19.0405 50.0866L13.1775 49.1479L11.3566 42.25Z",
    fill: "#F2F4F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6066 133.25L10.6261 140.087L4.64307 141.311L10.9863 142.678L12.5871 148.944L13.5876 142.372L19.2905 141.087L13.4275 140.148L11.6066 133.25Z",
    fill: "#F2F4F7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.607 117.25L188.626 124.087L182.643 125.311L188.986 126.678L190.587 132.944L191.588 126.372L197.291 125.087L191.428 124.148L189.607 117.25Z",
    fill: "#F2F4F7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1248 117.25L25.6346 120.668L22.6431 121.281L25.8147 121.964L26.6151 125.097L27.1153 121.811L29.9668 121.168L27.0353 120.699L26.1248 117.25Z",
    fill: "#E2E5EC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1248 86.25L21.6346 89.6683L18.6431 90.2806L21.8147 90.9642L22.6151 94.0968L23.1153 90.8112L25.9668 90.1683L23.0353 89.6989L22.1248 86.25Z",
    fill: "#E2E5EC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.125 98.25L173.635 101.668L170.643 102.281L173.815 102.964L174.615 106.097L175.115 102.811L177.967 102.168L175.035 101.699L174.125 98.25Z",
    fill: "#E2E5EC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M189.801 77.9609L189.31 81.3793L186.319 81.9915L189.49 82.6752L190.291 85.8078L190.791 82.5221L193.643 81.8793L190.711 81.4099L189.801 77.9609Z",
    fill: "#E2E5EC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6431 162.25H173.643",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M179.143 162.25H193.143",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.64307 162.25H17.6431",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6597 84.0801C83.6597 81.8709 85.4505 80.0801 87.6597 80.0801H115.824C118.033 80.0801 119.824 81.8709 119.824 84.0801V162.08H83.6597V84.0801Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7417 142.552C92.7417 141.447 93.6371 140.552 94.7417 140.552H108.742C109.846 140.552 110.742 141.447 110.742 142.552V162.25H92.7417V142.552Z",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2886 111.25C42.2886 109.041 44.0794 107.25 46.2886 107.25H83.6577V162.25H46.2886C44.0794 162.25 42.2886 160.459 42.2886 158.25V111.25Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M83.6577 117.25H42.9448V119.25H83.6577V117.25Z",
    fill: "#1A1E23"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M119 84.3596H84.481V87.3596H119V84.3596Z",
    fill: "#1A1E23"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96.918,
    y: 121.264,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.1948,
    y: 140.551,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68.1948,
    y: 121.264,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119.824 106.25H156.396C158.605 106.25 160.396 108.041 160.396 110.25V158.25C160.396 160.459 158.605 162.25 156.396 162.25H119.824V106.25Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M160.396 117.25H119.824V119.25H160.396V117.25Z",
    fill: "#1A1E23"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M77.1948 122.25H69.1948V124.25H77.1948V122.25Z",
    fill: "#1A1E23"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M77.1948 141.25H69.1948V143.25H77.1948V141.25Z",
    fill: "#1A1E23"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9995,
    y: 140.551,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 48.9995,
    y: 121.264,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M57.9995 122.25H49.9995V124.25H57.9995V122.25Z",
    fill: "#1A1E23"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M57.9995 141.25H49.9995V143.25H57.9995V141.25Z",
    fill: "#1A1E23"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M105.643 122.25H97.6431V124.25H105.643V122.25Z",
    fill: "#1A1E23"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M109.912 141.25H93.644V144.25H109.912V141.25Z",
    fill: "#1A1E23"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 125.955,
    y: 140.551,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 125.955,
    y: 121.264,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M134.955 122.25H126.955V124.25H134.955V122.25Z",
    fill: "#1A1E23"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.644,
    cy: 99.25,
    rx: 7.60497,
    ry: 8,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M101.644 94.5464C105.862 94.5464 109.308 97.4499 109.622 101.14C109.633 100.923 109.644 100.715 109.644 100.489C109.644 95.8761 106.064 92.1404 101.644 92.1404C97.2245 92.1404 93.644 95.8851 93.644 100.489C93.644 100.706 93.644 100.923 93.6664 101.14C93.9797 97.4499 97.4371 94.5464 101.644 94.5464Z",
    fill: "#1A1E23"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M104.977 101.25L101.644 99.25V95.25",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M134.955 141.25H126.955V143.25H134.955V141.25Z",
    fill: "#1A1E23"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 145.15,
    y: 140.551,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 145.15,
    y: 121.264,
    width: 9.64384,
    height: 9.64384,
    rx: 2,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M154.15 122.25H146.15V124.25H154.15V122.25Z",
    fill: "#1A1E23"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M154.15 141.25H146.15V143.25H154.15V141.25Z",
    fill: "#1A1E23"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M100.462 68.1163C101.166 67.6006 102.122 67.6006 102.826 68.1163L119.23 80.1368C120.789 81.2795 119.981 83.75 118.048 83.75H85.2403C83.307 83.75 82.4987 81.2795 84.0582 80.1368L100.462 68.1163Z",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M119.824 84.1267V81.113L101.766 67.25L83.6597 81.113V84.1267L101.742 70.8664L119.824 84.1267Z",
    fill: "#1A1E23"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2886 110.25C42.2886 108.041 44.0794 106.25 46.2886 106.25H83.6577V116.25H42.2886V110.25Z",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.824 106.25H156.396C158.605 106.25 160.396 108.041 160.396 110.25V116.25H119.824V106.25Z",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M83.6577 107.25H42.9448V109.25H83.6577V107.25Z",
    fill: "#1A1E23"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M160.395 107.25H119.824V109.25H160.395V107.25Z",
    fill: "#1A1E23"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 30.6431,
    y: 128.25,
    width: 34,
    height: 34,
    rx: 4,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6431 155.495H60.6431",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6431 155.495L34.6431 135.25",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M49.695 139.652H46.9581C46.5805 139.652 46.2739 140.154 46.2739 140.772V150.854C46.2739 151.473 46.5805 151.975 46.9581 151.975H49.695C50.0727 151.975 50.3792 151.473 50.3792 150.854V140.772C50.3792 140.154 50.0727 139.652 49.695 139.652Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4855 143.171H38.7487C38.371 143.171 38.0645 143.735 38.0645 144.429V150.716C38.0645 151.41 38.371 151.973 38.7487 151.973H41.4855C41.8632 151.973 42.1697 151.41 42.1697 150.716V144.429C42.1697 143.735 41.8632 143.171 41.4855 143.171Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9069 135.25H55.1701C54.7924 135.25 54.4858 135.75 54.4858 136.365V150.859C54.4858 151.475 54.7924 151.974 55.1701 151.974H57.9069C58.2846 151.974 58.5911 151.475 58.5911 150.859V136.365C58.5911 135.75 58.2846 135.25 57.9069 135.25Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M63.7481 129.06H31.5376V131.488H63.7481V129.06Z",
    fill: "#1A1E23"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M64.6429 159.012H31.5376V161.441H64.6429V159.012Z",
    fill: "#1A1E23"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 155.643,
    cy: 145.25,
    r: 17,
    fill: "#9C82FA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M144.433 144.543C144.245 144.73 144.14 144.985 144.14 145.25C144.14 145.515 144.245 145.77 144.433 145.957L152.103 153.627C152.493 154.017 153.126 154.017 153.517 153.627L166.853 140.29C167.244 139.9 167.244 139.267 166.853 138.876L164.85 136.873C164.663 136.686 164.408 136.58 164.143 136.58C163.878 136.58 163.624 136.686 163.436 136.873L152.81 147.499L147.85 142.54C147.46 142.149 146.826 142.149 146.436 142.54L144.433 144.543ZM146.754 131.946C149.385 130.189 152.478 129.25 155.642 129.25C159.882 129.263 163.944 130.953 166.942 133.951C169.94 136.949 171.63 141.012 171.643 145.252C171.643 148.416 170.704 151.508 168.947 154.139C167.188 156.77 164.69 158.821 161.766 160.032C158.842 161.243 155.625 161.56 152.522 160.943C149.418 160.325 146.567 158.801 144.329 156.564C142.092 154.326 140.568 151.475 139.951 148.371C139.333 145.268 139.65 142.051 140.861 139.127C142.072 136.203 144.123 133.705 146.754 131.946Z",
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M155.649 133.502C147.432 133.502 140.72 138.987 140.109 145.958C140.088 145.547 140.066 145.154 140.066 144.727C140.066 136.014 147.04 128.958 155.649 128.958C164.258 128.958 171.232 136.031 171.232 144.727C171.232 145.137 171.232 145.547 171.189 145.958C170.579 138.987 163.844 133.502 155.649 133.502Z",
    fill: "#1A1E23"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.088,
    cy: 110.694,
    r: 8.44444,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M164.143 105.656C159.661 105.656 156 108.56 155.667 112.25C155.655 112.033 155.643 111.825 155.643 111.599C155.643 106.986 159.447 103.25 164.143 103.25C168.839 103.25 172.643 106.995 172.643 111.599C172.643 111.816 172.643 112.033 172.619 112.25C172.286 108.56 168.613 105.656 164.143 105.656Z",
    fill: "#1A1E23"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M166.105 108.073C165.98 106.977 164.786 106.731 163.74 106.727C162.373 106.721 161.008 107.895 161.49 109.144C161.964 110.37 163.582 110.612 164.757 111.048C165.267 111.236 165.861 111.492 166.145 111.939C166.496 112.493 166.404 113.159 166.018 113.677C165.631 114.195 165.012 114.504 164.313 114.612C163.177 114.788 161.551 114.542 161.155 113.407C161.088 113.215 161.066 113.013 161.075 112.813",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M163.717 105.668V115.721",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.088,
    cy: 80.6944,
    r: 8.44444,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M175.143 75.656C170.661 75.656 167 78.5595 166.667 82.25C166.655 82.0329 166.643 81.8249 166.643 81.5987C166.643 76.9857 170.447 73.25 175.143 73.25C179.839 73.25 183.643 76.9947 183.643 81.5987C183.643 81.8158 183.643 82.0329 183.619 82.25C183.286 78.5595 179.613 75.656 175.143 75.656Z",
    fill: "#1A1E23"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M177.105 78.0731C176.98 76.9767 175.786 76.7306 174.74 76.7266C173.373 76.7206 172.008 77.895 172.49 79.1435C172.964 80.37 174.582 80.6121 175.757 81.0483C176.267 81.2363 176.861 81.4924 177.145 81.9386C177.496 82.4928 177.404 83.1591 177.018 83.6773C176.631 84.1955 176.012 84.5036 175.313 84.6116C174.177 84.7877 172.551 84.5416 172.155 83.4072C172.088 83.2151 172.066 83.013 172.075 82.8129",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M174.717 75.668V85.7209",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.088,
    cy: 90.6944,
    r: 8.44444,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M152.143 85.656C147.661 85.656 144 88.5595 143.667 92.25C143.655 92.0329 143.643 91.8249 143.643 91.5987C143.643 86.9857 147.447 83.25 152.143 83.25C156.839 83.25 160.643 86.9947 160.643 91.5987C160.643 91.8158 160.643 92.0329 160.619 92.25C160.286 88.5595 156.613 85.656 152.143 85.656Z",
    fill: "#1A1E23"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M154.105 88.0731C153.98 86.9767 152.786 86.7306 151.74 86.7266C150.373 86.7206 149.008 87.895 149.49 89.1435C149.964 90.37 151.582 90.6121 152.757 91.0483C153.267 91.2363 153.861 91.4924 154.145 91.9386C154.496 92.4928 154.404 93.1591 154.018 93.6773C153.631 94.1955 153.012 94.5036 152.313 94.6116C151.177 94.7877 149.551 94.5416 149.155 93.4072C149.088 93.2151 149.066 93.013 149.075 92.8129",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M151.717 85.668V95.7209",
    stroke: "#1A1E23",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.3853,
    cy: 97.1177,
    r: 14,
    fill: "#F9FAFC",
    stroke: "#1A1E23",
    strokeWidth: 2
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7319 100.909L38.6884 96.3342L42.6535 99.9943L50.0882 93.1316",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1377 92.7427H49.7523H50.2627V98.8677",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M42.3842 87.638C35.4125 87.638 29.7168 92.1546 29.199 97.8953C29.1805 97.5576 29.162 97.234 29.162 96.8822C29.162 89.7063 35.0796 83.8953 42.3842 83.8953C49.6888 83.8953 55.6064 89.7204 55.6064 96.8822C55.6064 97.2199 55.6064 97.5576 55.5695 97.8953C55.0517 92.1546 49.3374 87.638 42.3842 87.638Z",
    fill: "#1A1E23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentLoan);
export default __webpack_public_path__ + "static/media/student-loan.56c72bc54e44bbfd4aca94daff233d35.svg";
export { ForwardRef as ReactComponent };